/**
* @license Apache-2.0
*
* Copyright (c) 2024 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Compute the cosecant of a degree.
*
* @module @stdlib/math-base-special-cscd
*
* @example
* var cscd = require( '@stdlib/math-base-special-cscd' );
*
* var v = cscd( 30 );
* // returns ~2.0
*
* var v = cscd( 45 );
* // returns ~1.41
*
* var v = cscd( 60 );
* // returns ~1.15
*
* var v = cscd( 90 );
* // returns 1.0
*
* var v = cscd( 0 );
* // returns Infinity
*
* var v = cscd( NaN );
* // returns NaN
*/

// MODULES //

var main = require( './main.js' );


// EXPORTS //

module.exports = main;
